module.exports = __webpack_public_path__ + "media/images/loader-86f6e7548fcdb3606871a35585938e02.gif";